module.exports = __webpack_public_path__ + "static/media/d.7812fa9d.png";